var map = {
	"./api.base.js": 84886,
	"./apisetup.js": 32662,
	"./dev.endpoints.js": 46160,
	"./devapis/applications.api.js": 50634,
	"./devapis/customer.api.js": 48481,
	"./devapis/leads.api.js": 30979,
	"./devapis/masterdata.api.js": 30263,
	"./devapis/underwriter.api.js": 38727,
	"./endpoints.js": 53085,
	"./index.js": 33191,
	"./prod.endpoints.js": 52690,
	"./staging.endpoints.js": 39496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74450;